export default __webpack_public_path__ + "static/media/hero-img.612ac379.png";